import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Box from "@mui/material/Box";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import api from '@/utils/connector/ApiConnector';


export default function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? undefined;

  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    if (!token) setMessage('Token não foi fornecido. Verifique o link enviado por e-mail.');
  }, [token]);

  const handleSubmit = async (e?: React.FormEvent) => {
    e?.preventDefault();
    setMessage(null);
    if (!token) { setMessage('Token inválido.'); return; }
    if (!password || password.length < 6) { setMessage('Senha deve ter ao menos 6 caracteres.'); return; }
    if (password !== password2) { setMessage('As senhas não coincidem.'); return; }
    setLoading(true);
    try {
      await api.post('/user/reset-password', { token, newPassword: password });
      setMessage('Senha redefinida com sucesso. Você será redirecionado para login.');
      window.setTimeout(() => navigate('/login'), 2000);
    } catch (err: any) {
      console.error('Erro reset-password:', err);
      const server = err?.response?.data?.message ?? 'Erro ao redefinir senha.';
      setMessage(server);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="centered-container" sx={{ maxWidth: 420, mx: 'auto', mt: 8, p: 3, bgcolor: 'background.paper', borderRadius: 2 }}>
      <Typography variant="h6" gutterBottom>Redefinir senha</Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>Insira a nova senha para sua conta.</Typography>

      <form onSubmit={handleSubmit}>
        <TextField
          label="Nova senha"
          type="password"
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <TextField
          label="Confirme a nova senha"
          type="password"
          fullWidth
          margin="normal"
          value={password2}
          onChange={(e) => setPassword2(e.target.value)}
          required
        />

        {message && <Typography sx={{ mt: 1, mb: 1 }}>{message}</Typography>}

        <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1, mt: 2 }}>
          <Button variant="outlined" onClick={() => navigate('/login')} disabled={loading}>Voltar</Button>
          <Button variant="contained" type="submit" disabled={loading}>
            {loading ? 'Enviando...' : 'Redefinir senha'}
          </Button>
        </Box>
      </form>
    </Box>
  );
}
